<div class="dt-container">
  <div class="dt-scroll">
    <table class="dt-table" [class.dt-striped]="stripes">
      <colgroup>
        @for (column of columns; track column.field) {
          <col [style.width]="column.width || null" />
        }
        @if (showView) {
          <col class="dt-action-col" />
        }
      </colgroup>

      <thead>
        <tr>
          @for (column of columns; track column.field) {
            <th scope="col"
              [class.dt-align-center]="column.align === 'center'"
              [class.dt-align-right]="column.align === 'right'"
              [class.dt-hide-mobile]="column.hideOnMobile"
              [class.dt-sortable]="column.sortable"
              (click)="onHeaderClick(column)">
              {{ column.header }}
              @if (column.sortable && sortField === column.field) {
                <mat-icon class="dt-sort-icon">{{ sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              }
            </th>
          }
          @if (showView) {
            <th scope="col" class="dt-align-right">Action</th>
          }
        </tr>
      </thead>

      <tbody>
        @if (loading) {
          <tr class="dt-message-row">
            <td [attr.colspan]="columnCount">Loading…</td>
          </tr>
        } @else if (!hasData) {
          <tr class="dt-message-row">
            <td [attr.colspan]="columnCount">{{ emptyMessage }}</td>
          </tr>
        } @else {
          @for (row of pagedData; track $index) {
            <tr [class.dt-clickable]="rowClick.observed" [ngStyle]="rowStyleFor(row, $index)" (click)="onRowClick(row)">
              @for (column of columns; track column.field) {
                <td [attr.data-label]="column.header"
                  [class.dt-align-center]="column.align === 'center'"
                  [class.dt-align-right]="column.align === 'right'"
                  [class.dt-hide-mobile]="column.hideOnMobile">
                  @switch (column.type) {
                    @case ('pill') {
                      <app-status-pill [label]="value(row, column.field)"
                        [variant]="pillVariant(column, row)"></app-status-pill>
                    }
                    @case ('date') {
                      {{ value(row, column.field) | date: (column.dateFormat || 'dd/MM/yyyy') }}
                    }
                    @case ('template') {
                      <ng-container
                        *ngTemplateOutlet="templateFor(column.templateName || column.field); context: { $implicit: row, index: $index }">
                      </ng-container>
                    }
                    @default {
                      {{ value(row, column.field) }}
                    }
                  }
                </td>
              }
              @if (showView) {
                <td class="dt-align-right">
                  <button type="button" class="dt-view-btn" aria-label="View"
                    (click)="onView(row, $event)">
                    <mat-icon>visibility</mat-icon>
                  </button>
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  @if (hasData && !loading) {
    <app-table-pagination
      [page]="page"
      [pageSize]="pageSize"
      [total]="total"
      [pageSizeOptions]="pageSizeOptions"
      [showPageSizeSelector]="showPageSizeSelector"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </app-table-pagination>
  }
</div>
